import { useState } from "react";
import { API } from "aws-amplify";
import Cookie from 'js-cookie';
import { base64encode, base64decode } from 'nodejs-base64';


import { onError } from "../libs/errorLib";

async function validateUser(fullname, email, password, roles) {
    try {
      let validUser = await API.post("vivelo", "/auth/users/exists", {
          body: {
              email: email,
          }
      });
      if (validUser != null) {
        return validUser.userExists
      } else {
        throw new Error("Error checking user exists")
      }      

    } catch (e) {
      onError(e)      
      throw e
    }

  }

export function useAuth(initSession, initIsAuthenticating, initIsAuthenticated) {
    const [session, setSession] = useState(initSession);
    const [isAuthenticating, setIsAuthenticating] = useState(initIsAuthenticating);
    const [isAuthenticated, userHasAuthenticated] = useState(initIsAuthenticated);    

    const sessionCookie = 'eventSession'

    function getSession() {
        try {
            setIsAuthenticating(true)

            if (session)
                return session
            
            const sess = Cookie.get(sessionCookie)
            if (sess != null) {
                let sessObj = JSON.parse(base64decode(sess))
                console.log(sessObj)
                setSession(sessObj)
                userHasAuthenticated(true);
                return sessObj
            }
            return null
        } finally {
            setIsAuthenticating(false)
        }
    }

    async function login(email, password) {
        try {
            setIsAuthenticating(true)        
    
            let result = await API.post("vivelo", "/auth/login", {
                body: {
                    username: email,
                    password: password,
                    role: ['Producer','Admin'],
                    forceLogin: true
                }
            });
            console.info('Login successful')
    
            let producers = await API.get("vivelo", `/producers/?user=${result.user._id}`);
        
            const session = {
                user: result.user,
                producers: producers.items,
                session: result.session
            }
            Cookie.set(sessionCookie, base64encode(JSON.stringify(session)), { expires: 1 })
            setSession(session)
            userHasAuthenticated(true);  
            setIsAuthenticating(false)
    
            return session   
      
          } catch (e) {
              onError(e);
              setIsAuthenticating(false)
              throw e
          }
    }

    async function logout() {
        if (isAuthenticated && session) {
            try {
                const id = session.session._id
                const result = await API.put('vivelo',`/auth/sessions/${id}/logout`, )
                console.log(result)

                Cookie.remove(sessionCookie);
                setSession(null);
                userHasAuthenticated(false);
                return true;
            } catch(e) {
                if (e.response.status === 400) { // session expired
                    console.log('session expired')
                    Cookie.remove(sessionCookie);
                    userHasAuthenticated(false);
                    setSession(null);                                
                } else {
                    console.log(e.response)                    
                }
                return false
            }
        }
    }

    async function signup(fullname, email, password, roles) {
        try {
            const userExists = await validateUser(fullname, email, password, roles);
            if (userExists) {
                return false    
            }

            let user = await API.post("vivelo", "/auth/users", {
                body: {
                    username: email,
                    password: password,
                    email: email,
                    fullname: fullname,
                    roles: roles
                }
            });
            console.log(user)
    
            let viewer = await API.post("vivelo", "/viewers/viewers", {
                body: {
                    user_uid: user._id
                }
            });
            console.log(viewer)
    
            let userSession = await API.post("vivelo", "/auth/sessions", {
                body: {
                    user_uid: user._id,
                    username: user.username,
                    role: 'Viewer'
                }
            });
            console.log(userSession)
    
            const session = {
                user: user,
                viewer: viewer,
                session: userSession
            }
            Cookie.set(sessionCookie, base64encode(JSON.stringify(session)), { expires: 1 })
            setSession(session)
            userHasAuthenticated(true);     
    
            return session; 
        } catch (e) {
            onError(e);
            throw e
        }  
    }
    
    return [isAuthenticating, setIsAuthenticating, isAuthenticated, userHasAuthenticated, getSession, setSession, signup, login, logout ];    
}